import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { streamVideoSuccess } from '../../actions/InfluencerCampaignActions/streamVideoActions';
import { streamVideoFailure } from '../../actions/InfluencerCampaignActions/streamVideoActions';

function* streamVideo({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.streamVideo + `?contentPath=${payload.s3ContentPath}`,
            isAuth: true,
        });
        console.log('====================================');
        console.log("STREAM_VIDEO_SUCCESS status :", response.data.status);
        console.log("STREAM_VIDEO_SUCCESS data :", response.data.response);
        console.log("STREAM_VIDEO_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            streamVideoSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("STREAM_VIDEO_FAILURE status :", error?.response?.status);
        console.log("STREAM_VIDEO_FAILURE data:", error?.response?.data);
        console.log("STREAM_VIDEO_FAILURE error :", error);
        console.log('====================================');
        yield put(streamVideoFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* streamVideoSaga() {
    yield takeLatest(actionTypes.STREAM_VIDEO_REQUEST, streamVideo);
}

export default streamVideoSaga;
